import { render, staticRenderFns } from "./SignupConfirmation.vue?vue&type=template&id=551beaee&scoped=true&"
import script from "./SignupConfirmation.vue?vue&type=script&lang=js&"
export * from "./SignupConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SignupConfirmation.vue?vue&type=style&index=0&id=551beaee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551beaee",
  null
  
)

export default component.exports